<template>
    <div class="flex flex-row gap-4 items-center text-5xl">
        <BrainIcon class="size-12 text-gray-600" />
        <ScenarioIndex
            :year="props.scenarioYear"
            :index="props.scenarioIndex"
            :max-digits="props.scenarioIndexMaxDigits"
        />
        <span>
            <span class="font-light text-gray-400">(</span>
            <span class="font-semibold text-gray-700">{{ props.scenarioName }}</span>
            <span class="font-light text-gray-400">)</span>
        </span>
        <Tooltip v-if="props.hasUnsavedChanges" placement="bottom">
            <template #trigger="tooltipProps">
                <span
                    v-bind="tooltipProps"
                    class="text-red-700 font-bold focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-gray-700 rounded h-8 -translate-y-2"
                    tabindex="0"
                >
                    *
                </span>
            </template>

            <template #text>{{ $t('scenario-switcher-unsaved-changes') }}</template>
        </Tooltip>
    </div>
</template>

<script setup lang="ts">
import BrainIcon from '../Icon/BrainIcon.vue';
import ScenarioIndex from '../ScenarioIndex/ScenarioIndex.vue';
import Tooltip from '../Tooltip/Tooltip.vue';

type ScenarioLinkButtonProps = {
    scenarioIndex: number;
    scenarioIndexMaxDigits: number;
    scenarioYear: number;
    scenarioName: string;
    hasUnsavedChanges: boolean;
};

const props = defineProps<ScenarioLinkButtonProps>();
</script>
